import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Loader2 } from 'lucide-react';
import PageHeader from '../components/common/PageHeader';

const Contact = () => {
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://formsubmit.co/ajax/detaydeck@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(Object.fromEntries(formData))
      });

      const data = await response.json();

      if (data.success) {
        // Form başarıyla gönderildi, yönlendirme yap
        window.location.href = window.location.hostname === 'localhost'
          ? 'http://localhost:3000/tesekkurler'
          : 'https://detaydeck.com/tesekkurler';
      } else {
        setStatus({ type: 'error', message: 'Bir hata oluştu. Lütfen tekrar deneyin.' });
        setIsSubmitting(false);
      }
    } catch (error) {
      setStatus({ type: 'error', message: 'Bir hata oluştu. Lütfen tekrar deneyin.' });
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="İletişim"
        description="Bizimle iletişime geçin, size yardımcı olmaktan mutluluk duyarız"
        backgroundImage="/images/hero-bg.jpg"
      />
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Sol Taraf - İletişim Bilgileri */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="bg-white p-8 rounded-2xl shadow-lg"
          >
            <div className="space-y-6">
              {/* Showroom */}
              <div>
                <h3 className="font-semibold text-lg mb-4">SHOWROOM</h3>
                <div className="space-y-2 text-gray-600">
                  <p>Pazartesi - Cumartesi: 09:00 - 18:00</p>
                  <p>Pazar: Kapalı</p>
                  <p>Adres: Ahmediye, Çatalca Yolu Cd. No:201, 34537</p>
                  <p>Büyükçekmece/İstanbul</p>
                </div>
              </div>

              {/* İletişim Bilgileri */}
              <div className="pt-6 border-t">
                <h3 className="font-semibold text-lg mb-4">Müşteri Hizmetleri</h3>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <Phone className="w-5 h-5 text-[#c8bca4]" />
                    <a href="tel:+905387416525" className="text-gray-600 hover:text-gray-800">
                      0538 741 65 25
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Phone className="w-5 h-5 text-[#c8bca4]" />
                    <a href="tel:+905321682948" className="text-gray-600 hover:text-gray-800">
                      0532 168 29 48
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="w-5 h-5 text-[#c8bca4]" />
                    <a href="mailto:detaydeck@gmail.com" className="text-gray-600 hover:text-gray-800">
                      detaydeck@gmail.com
                    </a>
                  </div>

                </div>
              </div>

              {/* Çalışma Saatleri */}
              <div className="pt-6 border-t">
                <h3 className="font-semibold text-lg mb-4">Çalışma Saatleri</h3>
                <div className="space-y-2 text-gray-600">
                  <p>Pazartesi - Cuma: 09:00 - 18:00</p>
                  <p>Cumartesi: 10:00 - 15:00</p>
                  <p>Pazar: Kapalı</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Sağ Taraf - İletişim Formu */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="bg-white p-8 rounded-2xl shadow-lg"
          >
            <h3 className="font-semibold text-lg mb-6">Mesaj Gönderin</h3>
            {status.message && (
              <div className={`p-4 rounded-lg mb-4 ${status.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                {status.message}
              </div>
            )}
            <form
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              <input type="hidden" name="_subject" value="Yeni İletişim Formu Mesajı!" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />

              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  İsim
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#c8bca4] focus:border-transparent"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  E-posta
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#c8bca4] focus:border-transparent"
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                  Telefon
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#c8bca4] focus:border-transparent"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Mesaj
                </label>
                <textarea
                  name="message"
                  rows="4"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#c8bca4] focus:border-transparent"
                ></textarea>
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full bg-[#c8bca4] text-white py-3 rounded-lg transition-colors relative ${isSubmitting ? 'opacity-70 cursor-not-allowed' : 'hover:bg-[#b5a791]'
                  }`}
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-2">
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Gönderiliyor...
                  </span>
                ) : (
                  'Gönder'
                )}
              </button>
            </form>

            {/* Loading Overlay */}
            {isSubmitting && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
                  <Loader2 className="w-12 h-12 animate-spin text-[#c8bca4] mx-auto mb-4" />
                  <p className="text-gray-700">Mesajınız Gönderiliyor...</p>
                </div>
              </div>
            )}
          </motion.div>
        </div>

        {/* Harita */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-12 rounded-2xl overflow-hidden shadow-lg h-[450px]"
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.194426002061!2d28.515395500000004!3d41.0865984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b5678098254491%3A0xca65785d488f2cd1!2sDetay%20Deck%20-%20Kompozit%20Deck%20%26%20Havuz%20kenar%C4%B1!5e0!3m2!1str!2str!4v1769776066037!5m2!1str!2str"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Detay Deck Showroom Konumu"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
